module.exports = __webpack_public_path__ + "img/home-dog-1.8d9dbf4b.jpg";